import type { MainViewMode } from "~/types/entity/cWebCatalog";

export const useMainViewModeState = () => useState<MainViewMode>("useMainViewModeState", () => "TOP_PAGE");
